<!-- Header -->
<div data-test-id="dialogHeaderContainer" class="dialog__header">
    <!-- Title -->
    <div data-test-id="title" class="dialog__title">{{ title }}</div>

    <!-- Close button -->
    <button data-test-id="closeActionButton" mat-icon-button [matTooltip]="CLOSE_LOCALIZED" (click)="close()" tabindex="-1" [hidden]="hiddenCloseButton">
        <mat-icon data-test-id="icon">clear</mat-icon>
    </button>
</div>

<!-- Contents -->
<div data-test-id="dialogContentContainer" class="dialog__content">
    <ng-content></ng-content>
</div>

<!-- Actions -->
<div data-test-id="dialogActionsContainer" class="dialog__actions">
    <div class="dialog__actions-inner">
        <ng-content select="[uiDialogActions]"></ng-content>
    </div>
</div>
